
    import Vue from 'vue';
    import {mapState} from 'vuex';
    import { 
      InstagramIcon, 
      YoutubeIcon, 
      FacebookIcon, 
      MailIcon,
      SmartphoneIcon,
      PhoneIcon 
    }
    from 'vue-feather-icons';
    export default Vue.extend({
    name: 'RomaFooter',
    props: {},
    components:{
      InstagramIcon,
      YoutubeIcon,
      FacebookIcon, 
      MailIcon,
      SmartphoneIcon,
      PhoneIcon
    },
    data() {
        return {
            language: this.$store.state.config.selectedLanguage,
        };
    },
    computed: {
        ...mapState({
            phoneContact: (state: any) => state.info.contact.sac,
            mobileContact: (state: any) => state.info.contact.phone,
            emailContact: (state: any) => ({ email: state.info.contact.email, url: `mailto://${state.info.contact.email}` }),
            social: (state: any) => state.info.social,
            languages: (state: any) => state.languages,
        }),
    },
    methods: {
      selectLanguage() {
          this.$store.commit('selectLanguage', this.language);
      },
    },
});
